import { render, staticRenderFns } from "./EditForceUpdateConfigDialog.vue?vue&type=template&id=72467dbf&"
import script from "./EditForceUpdateConfigDialog.vue?vue&type=script&lang=js&"
export * from "./EditForceUpdateConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports